module.exports = __webpack_public_path__ + "static/lbs-71b159d48aeda1d41c74624d1c951333.jpg";